/* ============================================================
   CUSTOM.js — SnootLabs
   Alle custom JavaScript voor SnootLabs los van Dawn's JS
   Laad deze file via theme.liquid voor </body>:
   <script src="{{ 'CUSTOM.js' | asset_url }}" defer="defer"></script>
   ============================================================ */


/* ------------------------------------------------------------
   1. REVEAL — gedeelde scroll-in animatie
   Eén observer voor alle CUSTOM-secties. Elk element met
   .snoot-reveal krijgt .is-in zodra zijn sectie in beeld komt;
   items binnen dezelfde sectie cascaderen met --reveal-stagger.
   Styling + timing staan in CUSTOM.css (.snoot-reveal / tokens).
   ------------------------------------------------------------ */
(function () {
  // Stagger uit de CSS-token lezen (ms of s), met veilige fallback.
  function staggerMs() {
    var raw = getComputedStyle(document.documentElement)
      .getPropertyValue('--reveal-stagger').trim();
    var n = parseFloat(raw);
    if (isNaN(n)) return 80;
    return raw.indexOf('ms') === -1 && raw.indexOf('s') !== -1 ? n * 1000 : n;
  }

  function reveal(section) {
    var step = staggerMs();
    section.querySelectorAll('.snoot-reveal').forEach(function (el, i) {
      setTimeout(function () { el.classList.add('is-in'); }, i * step);
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = [];
    scope.querySelectorAll('.snoot-reveal').forEach(function (el) {
      var section = el.closest('.shopify-section') || el.parentElement;
      if (section && sections.indexOf(section) === -1) sections.push(section);
    });
    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(reveal);
      return;
    }
    // Twee drempels: 10% van de sectie in beeld, óf minstens een kwart van
    // het scherm gevuld. Die tweede regel is er voor lange secties (een
    // paginabreed raster op mobiel): daar wordt 10% van de sectiehoogte
    // nooit gehaald en bleef de kop onzichtbaar.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var enough = e.intersectionRatio >= 0.1 ||
          e.intersectionRect.height >= window.innerHeight * 0.25;
        if (enough) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: [0, 0.1] });
    sections.forEach(function (section) { io.observe(section); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Theme editor: opnieuw scannen wanneer een sectie herlaadt.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ------------------------------------------------------------
   2. LINK PREFETCH
   Prefetcht interne pagina's zodra de muis erover hovert; cart en
   checkout uitgesloten.
   ------------------------------------------------------------ */
document.addEventListener('mouseover', function(e) {
  const link = e.target.closest('a[href^="/"]');
  if (!link) return;

  const href = link.getAttribute('href');

  // Sla lege links, cart en checkout over
  if (!href || href === '#') return;
  if (href.includes('/cart')) return;
  if (href.includes('/checkout')) return;

  // Niet dubbel prefetchen
  if (document.querySelector('link[rel="prefetch"][href="' + href + '"]')) return;

  const prefetch = document.createElement('link');
  prefetch.rel = 'prefetch';
  prefetch.href = href;
  document.head.appendChild(prefetch);
});

/* ------------------------------------------------------------
   3. ULTRA-SMALLE VIEWPORT — schaal-naar-passend (< 320px)
   CUSTOM.css houdt onder 320px een schone 320px-layout aan
   (body { min-width: 320px }). Hier schalen we die hele layout
   proportioneel omlaag zodat 'ie in een smallere viewport past —
   header, content én de zwevende koopbalk schalen als ÉÉN geheel,
   met dezelfde snelheid. Zo geen letter-voor-letter-instorting meer
   onder telefoonbreedte. Boven 320px: geen zoom. Zoom moet via JS
   omdat calc(100vw/320) geen geldige CSS zoom-waarde is.
   ------------------------------------------------------------ */
(function () {
  var el = document.documentElement;
  function fitNarrow() {
    // clientWidth = de ECHTE viewportbreedte en blijft stabiel óók als er al
    // een zoom op html staat (i.t.t. window.innerWidth, dat de gezoomde waarde
    // teruggeeft en zo een verkeerde meting/feedback zou geven).
    var w = el.clientWidth;
    el.style.zoom = w < 320 ? (w / 320) : '';
  }
  fitNarrow();
  window.addEventListener('resize', fitNarrow, { passive: true });
})();